export default __webpack_public_path__ + "static/media/Vazir-Light.06e0fe52.eot";